import { h } from 'preact'
import Icon from '../assets'
import Tooltip from '../ui-components/Tooltip'
import Phrase from '../../libs/translationsUtils/phrase'

const TopicShare = ({ className = '' }: { className?: string }) => {
  return (
    <Tooltip
      withArrow
      trigger={(
        <div className={className}>
          <Icon
            icon='share'
            size={16}
          />
          <span className='post-footer-item-text'><Phrase p='Share' /></span>
        </div>
      )}
      tooltipMessage={(
        <ul className=''>
          TBD
        </ul>
      )}
    />
  )
}

export default TopicShare
